import participantsListTable from './participantsListTable.container'

export default participantsListTable